import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { HintCoverageAccountType, allocateHintProperties } from '~/services/ConnectionGoogleService';

export function useAllocateHintProperties() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (accountType: HintCoverageAccountType) => {
      return await allocateHintProperties(accountType);
    },
    onSuccess: () => {
      enqueueSnackbar('Properties reclassification queued successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to reclassify properties: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
